import Button from "@/components/Button";
import Modal from "@/dsComponents/Modal";
import { ModalBody, ModalFooter, ModalFooterRight, ModalHeader, ModalTitle } from "@dextech-ai/dex-design-system";
import { InfoOutlined } from "@dextech-ai/dex-design-system/icons";
import PropTypes from "prop-types";

// Approve / reject confirmation for the admin approval requests (enrolment, persona and SGTraDex
// enrolment requests). Rejecting takes an optional reason.
const ApprovalRequestModal = ({ visible, hide, title, isApprove, isReject, onRejectReasonChange, onConfirm, submitTestId, reasonTestId }) => (
	<Modal visible={visible} close={hide}>
		<ModalHeader icon={<InfoOutlined data-ds-color="primary-dark" />}>
			<ModalTitle>{title}</ModalTitle>
		</ModalHeader>
		<ModalBody>
			<div>
				{isApprove && (
					<div className="action-modal__text">
						Are you sure you want to proceed to approve this request?
					</div>
				)}
				{isReject && (
					<>
						<div className="action-modal__text">
							Are you sure you want to reject this request? The requestor will be notified.
						</div>
						<textarea
							data-testid={reasonTestId}
							className="action-modal__rejection-textarea"
							placeholder="Reason for rejection (Optional)"
							onChange={(e) => onRejectReasonChange(e.target.value)}
						></textarea>
					</>
				)}
			</div>
		</ModalBody>
		<ModalFooter>
			<ModalFooterRight>
				<Button
					data-testid={submitTestId}
					full
					maxWidth="78"
					text={isApprove ? "Confirm" : "Reject"}
					submit={() => {
						hide();
						onConfirm();
					}}
				/>
			</ModalFooterRight>
		</ModalFooter>
	</Modal>
);

ApprovalRequestModal.propTypes = {
	visible: PropTypes.bool,
	hide: PropTypes.func.isRequired,
	title: PropTypes.node,
	isApprove: PropTypes.bool,
	isReject: PropTypes.bool,
	onRejectReasonChange: PropTypes.func.isRequired,
	onConfirm: PropTypes.func.isRequired,
	submitTestId: PropTypes.string,
	reasonTestId: PropTypes.string,
};

export default ApprovalRequestModal;
